// @ts-ignore
import { I18nextProvider } from "react-i18next";
// @ts-ignore
import i18n from "@projectdiction/translations";

import {
  BrowserRouter,
  CheckLoginWrapper,
  // @ts-ignore
} from "@projectdiction/common-react";

import App from "./components/App";

export default function Root() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter>
        <CheckLoginWrapper>
          <App />
        </CheckLoginWrapper>
      </BrowserRouter>
    </I18nextProvider>
  );
}
